import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import MySql from "../../homepage/header-banner/MySql";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
// import { MuiGrid } from '@mui/material';
import CardBox from "../../container/Box/Components/CardBox";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-vn";
import Cloudconsult2VN from "../../homepage/consult/cloudconsult-2-vn";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import HeaderVn from "../../detailpageVN/Page/component/headervn";
import FooterVn from "../../detailpageVN/Page/component/footervn";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClustercloudpostgresqldbVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private PostgreSQL Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for PostgreSQL")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Tự động chuyển đổi dự phòng (Failover), thiết lập hệ thống cơ sở dữ liệu phân tán hiệu suất cao</p>",
                                    `<p class='typo-14'>Hệ thống được triển khai mở rộng với các node đọc tự động trên nền tảng PostgreSQL kết hợp công cụ pg_auto_failover.</p>
                                <p class='typo-14'>Các container (POD) thuộc PostgreSQL Read có thể tự động mở rộng hoặc thu hẹp theo tải, hỗ trợ phân phối I/O hiệu quả.</p>
                                <p class='typo-14'>Khi phát sinh sự cố tại node chính hoặc bất kỳ node nào, hệ thống giám sát sẽ nhanh chóng phát hiện và thực hiện chuyển đổi dự phòng.</p>
                                <p class='typo-14'>Nhờ đó, các node đọc vẫn tiếp tục hoạt động bình thường theo chỉ dẫn của hệ thống giám sát, đảm bảo dịch vụ không bị gián đoạn.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Vận hành volume persistent hiệu năng cao, tối ưu hóa I/O</p>",
                                    `<p class='typo-14'>Hệ thống được triển khai trên ổ SSD với cấu hình gồm 3 container replica (POD) cho mỗi dịch vụ.</p>
                                <p class='typo-14'>Khi một node trong hệ thống Kubernetes gặp sự cố phần cứng, các container replica sẽ tự động tiếp quản, duy trì hoạt động dịch vụ trên các worker node khác mà không gián đoạn.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Tự động di chuyển container (POD) khi xảy ra sự cố phần cứng, đảm bảo hệ thống luôn ổn định</p>",
                                    `<p class='typo-14'>Các container (POD) chạy dịch vụ PostgreSQL trên Kubernetes được triển khai với 3 bản sao cho mỗi dịch vụ riêng biệt.</p> 
                                <p class='typo-14'>Nhờ phân phối các bản sao này trên nhiều worker node, khi một node gặp lỗi phần cứng, dịch vụ vẫn tiếp tục hoạt động ổn định nhờ các container replica còn lại.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Tự động mở rộng quy mô, điều chỉnh số lượng container (POD) để phân phối tải hiệu quả</p>",
                                    `<p class='typo-14'>Hệ thống giám sát mức sử dụng CPU, bộ nhớ hoặc các chỉ số tùy chỉnh khác để tự động điều chỉnh số lượng container (POD) phù hợp với nhu cầu tải.</p>
                                <p class='typo-14'>Khi cần mở rộng, hệ thống sẽ cấp phát thêm tài nguyên phần cứng và thực hiện cấu hình lại dịch vụ một cách linh hoạt.</p>
                                <p class='typo-14'>Giải pháp này giúp tối ưu hiệu suất, phân phối tài nguyên hợp lý và tiết kiệm chi phí vận hành.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-cloud-postgresql-db/postgresql_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        {/* <MySql title={"PostgreSQL"} content={"PostgreSQL"} content1={"PostgreSQL"}/> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClustercloudpostgresqldbVN;
